(() => {
  if (window.cpCatalogueViewReady) return;
  window.cpCatalogueViewReady = true;
  const validViews = ['wide', 'grid', 'list'];
  const applyView = (catalogue, view) => {
    catalogue.dataset.cpView = validViews.includes(view) ? view : 'grid';
    catalogue.querySelectorAll('[data-cp-view-choice]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.cpViewChoice === catalogue.dataset.cpView));
    });
  };
  const initialise = () => {
    let view = 'grid';
    try { view = sessionStorage.getItem('cp-catalogue-view') || 'grid'; } catch {}
    document.querySelectorAll('.cp-all-products').forEach((catalogue) => applyView(catalogue, view));
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cp-view-choice]');
    const catalogue = button?.closest('.cp-all-products');
    if (!catalogue) return;
    applyView(catalogue, button.dataset.cpViewChoice);
    try { sessionStorage.setItem('cp-catalogue-view', catalogue.dataset.cpView); } catch {}
  });
  document.addEventListener('shopify:section:load', initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
